"use strict";
!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{},n=(new e.Error).stack;n&&(e._sentryDebugIds=e._sentryDebugIds||{},e._sentryDebugIds[n]="4831e33c-4b77-50ed-b07a-3db2f181d026")}catch(e){}}();

Object.defineProperty(exports, "__esModule", { value: true });
exports.ContractType = exports.ExpenseTag = exports.VenueExpenseTag = exports.ArtistExpenseTag = exports.ShowStatus = exports.ShowDealType = void 0;
exports.showsForRun = showsForRun;
var ShowDealType;
(function (ShowDealType) {
    ShowDealType["FLAT_FEE"] = "Flat Fee";
    ShowDealType["REV_SPLIT"] = "Revenue Share";
    ShowDealType["VERSUS"] = "Versus";
})(ShowDealType || (exports.ShowDealType = ShowDealType = {}));
var ShowStatus;
(function (ShowStatus) {
    ShowStatus["DRAFT"] = "Draft";
    ShowStatus["CONFIRMED"] = "Confirmed";
    ShowStatus["SETTLED"] = "Settled";
    ShowStatus["PAID"] = "Paid";
})(ShowStatus || (exports.ShowStatus = ShowStatus = {}));
var ArtistExpenseTag;
(function (ArtistExpenseTag) {
    ArtistExpenseTag["ADVERTISING"] = "Advertising";
    ArtistExpenseTag["AUTO_INSURANCE"] = "Auto Insurance";
    ArtistExpenseTag["BACKLINE"] = "Backline";
    ArtistExpenseTag["BAGGAGE_FEES"] = "Baggage Fees";
    ArtistExpenseTag["BUS_RENTAL"] = "Bus Rental";
    ArtistExpenseTag["BUS_VAN_GAS"] = "Bus/Van Gas";
    ArtistExpenseTag["CAR_RENTAL"] = "Car Rental";
    ArtistExpenseTag["CATERING"] = "Catering";
    ArtistExpenseTag["CREW"] = "Crew";
    ArtistExpenseTag["EQUIPMENT_RENTAL"] = "Equipment Rental";
    ArtistExpenseTag["FLIGHTS"] = "Flights";
    ArtistExpenseTag["GAS"] = "Gas";
    ArtistExpenseTag["HOSPITALITY"] = "Hospitality";
    ArtistExpenseTag["HOTELS"] = "Hotels";
    ArtistExpenseTag["INSURANCE_OTHER"] = "Insurance (General)";
    ArtistExpenseTag["LASERS"] = "Lasers";
    ArtistExpenseTag["LIABILITY_INSURANCE"] = "Liability Insurance";
    ArtistExpenseTag["LIGHTING"] = "Lighting";
    ArtistExpenseTag["MARKETING"] = "Marketing";
    ArtistExpenseTag["MEAL_BUYOUTS"] = "Meal Buyouts";
    ArtistExpenseTag["PARKING"] = "Parking";
    ArtistExpenseTag["PER_DIEM"] = "Per Diem";
    ArtistExpenseTag["PRODUCTION_GENERAL"] = "Production (General)";
    ArtistExpenseTag["PROMOTIONAL"] = "Promotional";
    ArtistExpenseTag["PUBLIC_TRANSPORTATION"] = "Public Transportation";
    ArtistExpenseTag["PUBLICITY"] = "Publicity";
    ArtistExpenseTag["RIDESHARE_TAXI"] = "Rideshare Taxi";
    ArtistExpenseTag["SFX"] = "SFX";
    ArtistExpenseTag["SOUND"] = "Sound";
    ArtistExpenseTag["STAGING"] = "Staging";
    ArtistExpenseTag["TOUR_SUPPLIES"] = "Tour Supplies";
    ArtistExpenseTag["TRAVEL_INSURANCE"] = "Travel Insurance";
    ArtistExpenseTag["TRAVEL_OTHER"] = "Travel (General)";
    ArtistExpenseTag["TRUCKING"] = "Trucking";
    ArtistExpenseTag["VAN_RENTAL"] = "Van Rental";
    ArtistExpenseTag["VIDEO_AND_PHOTO"] = "Video & Photo";
    ArtistExpenseTag["MISC"] = "Misc";
})(ArtistExpenseTag || (exports.ArtistExpenseTag = ArtistExpenseTag = {}));
var VenueExpenseTag;
(function (VenueExpenseTag) {
    VenueExpenseTag["ADVERTISING"] = "Advertising";
    VenueExpenseTag["ASCAP"] = "ASCAP";
    VenueExpenseTag["BACKLINE"] = "Backline";
    VenueExpenseTag["BARRICADE"] = "Barricade";
    VenueExpenseTag["BMI"] = "BMI";
    VenueExpenseTag["BOX_OFFICE"] = "Box Office";
    VenueExpenseTag["CANCELLATION_INSURANCE"] = "Cancellation Insurance";
    VenueExpenseTag["CATERING"] = "Catering";
    VenueExpenseTag["CLEANUP"] = "Cleanup";
    VenueExpenseTag["FIRE_MEDICAL"] = "Fire/Medical";
    VenueExpenseTag["GMR"] = "GMR";
    VenueExpenseTag["HOSPITALITY"] = "Hospitality";
    VenueExpenseTag["HOUSE_NUT"] = "House Nut";
    VenueExpenseTag["INSURANCE"] = "Insurance";
    VenueExpenseTag["LICENSES"] = "Licenses";
    VenueExpenseTag["LIGHTING"] = "Lighting";
    VenueExpenseTag["MARKETING"] = "Marketing";
    VenueExpenseTag["POLICE"] = "Police";
    VenueExpenseTag["PRODUCTION_OTHER"] = "Production (General)";
    VenueExpenseTag["RENT"] = "Rent";
    VenueExpenseTag["RUNNER_AND_VANS"] = "Runner & Vans";
    VenueExpenseTag["SEATING"] = "Seating";
    VenueExpenseTag["SECURITY"] = "Security";
    VenueExpenseTag["SESAC"] = "SESAC";
    VenueExpenseTag["SFX"] = "SFX";
    VenueExpenseTag["SHOW_INSURANCE"] = "Show Insurance";
    VenueExpenseTag["SHUTTLE_TRUCKS"] = "Shuttle Trucks";
    VenueExpenseTag["SOUND"] = "Sound";
    VenueExpenseTag["STAFFING"] = "Staffing";
    VenueExpenseTag["STAGEHANDS"] = "Stagehands";
    VenueExpenseTag["STAGING"] = "Staging";
    VenueExpenseTag["TALENT"] = "Talent";
    VenueExpenseTag["TICKET_TAKERS"] = "Ticket Takers";
    VenueExpenseTag["TRAVEL_OTHER"] = "Travel (General)";
    VenueExpenseTag["USHERS"] = "Ushers";
    VenueExpenseTag["VARIABLE_OTHER"] = "Variable (General)";
    VenueExpenseTag["VENUE"] = "Venue";
    VenueExpenseTag["VIDEO"] = "Video";
    VenueExpenseTag["MISC"] = "Misc";
})(VenueExpenseTag || (exports.VenueExpenseTag = VenueExpenseTag = {}));
exports.ExpenseTag = {
    ...ArtistExpenseTag,
    ...VenueExpenseTag,
};
var ContractType;
(function (ContractType) {
    ContractType["SHOW_OFFER"] = "Show Offer";
    ContractType["LIVE_MUSIC_AGREEMENT"] = "Live Agreement";
    ContractType["LIVE_RIDER_AGREEMENT"] = "Rider Agreement";
    ContractType["RECORDING_COLLABORATION_AGREEMENT"] = "Side Artist Agreement";
    ContractType["COMPOSITION_COLLABORATION_AGREEMENT"] = "Side Composer Agreement";
    ContractType["RECORDING_CONTRACT"] = "Recording Contract";
    ContractType["RECORDING_PUBLISHING_AGREEMENT"] = "Publishing Agreement";
    ContractType["RECORDING_LICENSING_AGREEMENT"] = "Sync Agreement";
    ContractType["RECORDING_DISTRIBUTION_AGREEMENT"] = "Distribution Agreement";
    ContractType["RECORDING_LETTER_OF_DIRECTION"] = "LOD";
    ContractType["RECORDING_RECORD_LABEL_AGREEMENT"] = "Record Label Agreement";
    ContractType["ARTIST_MANAGEMENT_AGREEMENT"] = "Artist Management Agreement";
    ContractType["ARTIST_RECORD_LABEL_AGREEMENT"] = "Record Label Agreement";
    ContractType["ARTIST_MERCH_AGREEMENT"] = "Merch Agreement";
    ContractType["ARTIST_SPONSORSHIP_AGREEMENT"] = "Sponsorship Agreement";
    ContractType["ARTIST_CREW_AGREEMENT"] = "Crew Agreement";
    ContractType["LIVE_MUSIC_SETTLEMENT"] = "Live Settlement";
    ContractType["RECORDING_SYNC_LICENSING_REPORT"] = "Sync Licensing Report";
    ContractType["RECORDING_ROYALTY_REPORT"] = "Royalty Report";
    ContractType["RECORDING_PUBLISHING_REPORT"] = "Publishing Report";
    ContractType["RECORDING_STREAMING_REPORT"] = "Streaming Report";
    ContractType["ARTIST_SPONSORSHIP_REPORT"] = "Sponsorship Report";
    ContractType["ARTIST_MERCH_REPORT"] = "Merch Report";
    ContractType["MISC"] = "MISC";
    ContractType["ARTIST_VENDOR_AGREEMENT"] = "Vendor Agreement";
    ContractType["ARTIST_INSURANCE_AGREEMENT"] = "Insurance Agreement";
    ContractType["BRAND_DEAL"] = "Brand Deal";
    ContractType["INSURANCE_CONTRACT"] = "Insurance Contract";
})(ContractType || (exports.ContractType = ContractType = {}));
function showsForRun(shows, run) {
    if (!shows)
        return [];
    return shows.filter((show) => show.runID === run.id);
}
//# sourceMappingURL=show.js.map
//# debugId=4831e33c-4b77-50ed-b07a-3db2f181d026
